import e from "./ExtensionValue.vue.js";
import { Fragment as t, createBlock as n, createCommentVNode as r, createElementBlock as i, defineComponent as a, openBlock as o, renderList as s } from "vue";
//#region src/specification-extensions/SpecificationExtensions.vue?vue&type=script&setup=true&lang.ts
var c = {
	key: 0,
	class: "my-2 min-w-0 text-base"
}, l = /*@__PURE__*/ a({
	__name: "SpecificationExtensions",
	props: { extensions: {} },
	setup(a) {
		return (l, u) => Object.keys(a.extensions).length ? (o(), i("dl", c, [(o(!0), i(t, null, s(a.extensions, (t, r) => (o(), n(e, {
			key: r,
			name: r,
			value: t
		}, null, 8, ["name", "value"]))), 128))])) : r("", !0);
	}
});
//#endregion
export { l as default };

//# sourceMappingURL=SpecificationExtensions.vue.script.js.map